import imgIzzispazzia1 from "./img-izzispazzia (1).png";
import imgIzzispazzia2 from "./img-izzispazzia (2).png";
import imgIzzispazzia3 from "./img-izzispazzia (3).png";
import imgIzzispazzia4 from "./img-izzispazzia (4).png";

const imgIzzispazzia = [
  imgIzzispazzia1,
  imgIzzispazzia2,
  imgIzzispazzia3,
  imgIzzispazzia4,
];

export default imgIzzispazzia;
